import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from './../../services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
})
export class UserAvatarComponent implements OnInit {
  @Input()
  employeeId: number;
  avatar$: Observable<any>;

  constructor(
    private readonly userService: UserService,
    private sanitaizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.avatar$ = this.avatar$ = this.userService.getAvatar(this.employeeId);
  }
}
